"use client";

import { c as _c } from "react/compiler-runtime";
import { DocumentOut, TenderOut } from "@/client";
import { Conversation, ConversationContent, ConversationScrollButton } from "@/components/ai-elements/conversation";
import { Loader } from "@/components/ai-elements/loader";
import { Message, MessageAction, MessageActions, MessageContent, MessageResponse } from "@/components/ai-elements/message";
import { PromptInput, PromptInputBody, PromptInputFooter, type PromptInputMessage, PromptInputSubmit, PromptInputTextarea } from "@/components/ai-elements/prompt-input";
import { Reasoning, ReasoningContent, ReasoningTrigger } from "@/components/ai-elements/reasoning";
import { Shimmer } from "@/components/ai-elements/shimmer";
import { Button } from "@/components/ui/button";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { useChat } from "@ai-sdk/react";
import { ChevronDownIcon, ChevronUpIcon, CopyIcon, ExternalLinkIcon, FileTextIcon, MessageSquareIcon, RefreshCcwIcon, XIcon } from "lucide-react";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { toast } from "sonner";
const QUOTA_REDIRECT_DELAY_MS = 1500;
const getTenderThinkingMessage = (isStreaming: boolean, duration?: number) => {
  if (isStreaming || duration === 0) {
    return <Shimmer duration={1}>Pensando...</Shimmer>;
  }
  if (duration === undefined) {
    return <p>Pensó brevemente</p>;
  }
  return <p>Pensó durante {duration} segundos</p>;
};
export function TenderChat(t0) {
  const $ = _c(96);
  const {
    storeId,
    tender,
    isLoggedIn,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const router = useRouter();
  const [input, setInput] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const [selectedPage, setSelectedPage] = useState(null);
  const [sourcesOpen, setSourcesOpen] = useState(false);
  let t2;
  if ($[0] !== router) {
    t2 = {
      onError: error => {
        if (error.message.includes("QUOTA_EXCEEDED")) {
          toast.error("Has excedido la cuota de tu plan", {
            description: "Has alcanzado el l\xEDmite mensual de consultas al chatbot. Te llevamos a los planes\u2026"
          });
          setTimeout(() => router.push("/pricing"), QUOTA_REDIRECT_DELAY_MS);
          return;
        }
        toast.error("Error en el chat", {
          description: "Ha ocurrido un error procesando tu consulta. Int\xE9ntalo de nuevo en unos minutos."
        });
      }
    };
    $[0] = router;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    messages,
    sendMessage,
    status,
    regenerate,
    stop
  } = useChat(t2);
  let T0;
  let T1;
  let T2;
  let T3;
  let handleSubmit;
  let t10;
  let t11;
  let t12;
  let t13;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== disabled || $[3] !== isLoggedIn || $[4] !== messages || $[5] !== open || $[6] !== regenerate || $[7] !== router || $[8] !== selectedDocument || $[9] !== sendMessage || $[10] !== sourcesOpen || $[11] !== status || $[12] !== storeId || $[13] !== tender.documents || $[14] !== tender.title) {
    const sourceDocuments = tender.documents.filter(_temp);
    const handleReferenceClick = (referenceTitle, text, pageNumber) => {
      const matchingDoc = sourceDocuments.find(doc_0 => doc_0.title === referenceTitle);
      if (matchingDoc) {
        setSelectedDocument(matchingDoc);
        setSelectedPage(pageNumber ?? null);
        setSearchText(text.trim().slice(0, 200).trim());
        setSourcesOpen(false);
      }
    };
    let t14;
    if ($[31] !== sendMessage || $[32] !== storeId) {
      t14 = message => {
        const hasText = Boolean(message.text);
        if (!hasText) {
          return;
        }
        sendMessage({
          metadata: {
            storeId
          },
          text: message.text
        });
        setInput("");
      };
      $[31] = sendMessage;
      $[32] = storeId;
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    handleSubmit = t14;
    let t15;
    if ($[34] !== isLoggedIn || $[35] !== router) {
      t15 = newOpen => {
        if (!isLoggedIn && newOpen) {
          router.push("/login");
          return;
        }
        setOpen(newOpen);
      };
      $[34] = isLoggedIn;
      $[35] = router;
      $[36] = t15;
    } else {
      t15 = $[36];
    }
    const handleOpenChange = t15;
    T3 = Sheet;
    t11 = open;
    t12 = handleOpenChange;
    let t16;
    let t17;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <MessageSquareIcon className="size-4" />;
      t17 = <span className="font-semibold">Preguntar a la IA</span>;
      $[37] = t16;
      $[38] = t17;
    } else {
      t16 = $[37];
      t17 = $[38];
    }
    if ($[39] !== disabled) {
      t13 = <SheetTrigger asChild={true}><Button className="gap-2 bg-linear-to-r from-blue-600 to-purple-600 text-white shadow-md transition-all hover:from-blue-700 hover:to-purple-700 hover:shadow-lg" size="default" disabled={disabled}>{t16}{t17}</Button></SheetTrigger>;
      $[39] = disabled;
      $[40] = t13;
    } else {
      t13 = $[40];
    }
    T2 = SheetContent;
    t9 = `flex w-full flex-col transition-all ${selectedDocument ? "sm:max-w-[80vw]" : "sm:max-w-2xl"}`;
    let t18;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <SheetTitle>Chat con IA sobre la licitación</SheetTitle>;
      $[41] = t18;
    } else {
      t18 = $[41];
    }
    if ($[42] !== tender.title) {
      t10 = <SheetHeader className="shrink-0 border-b pb-4">{t18}<SheetDescription className="line-clamp-2">{tender.title}</SheetDescription></SheetHeader>;
      $[42] = tender.title;
      $[43] = t10;
    } else {
      t10 = $[43];
    }
    t8 = "flex min-h-0 flex-1 gap-4 pt-4";
    t6 = "flex min-h-0 flex-1 flex-col gap-4";
    t7 = sourceDocuments.length > 0 && <Collapsible open={sourcesOpen} onOpenChange={setSourcesOpen} className="shrink-0 border-b px-6 py-3"><CollapsibleTrigger asChild={true}><Button variant="outline" size="sm" className="flex w-full justify-between"><span className="flex items-center gap-2"><FileTextIcon className="size-4" />Fuentes ({sourceDocuments.length})</span>{sourcesOpen ? <ChevronUpIcon className="size-4" /> : <ChevronDownIcon className="size-4" />}</Button></CollapsibleTrigger><CollapsibleContent className="mt-2 space-y-1">{sourceDocuments.map((doc_1, idx) => <button key={idx} onClick={() => {
          setSelectedDocument(doc_1);
          setSearchText(null);
          setSelectedPage(null);
        }} className={`text-muted-foreground hover:bg-accent hover:text-accent-foreground flex w-full items-start gap-2 rounded-md p-2 text-left text-sm transition-colors ${selectedDocument?.url === doc_1.url ? "bg-accent" : ""}`}><FileTextIcon className="mt-0.5 size-4 shrink-0" /><div className="flex-1 overflow-hidden"><div className="truncate font-medium">{doc_1.title}</div><div className="text-xs opacity-70">{doc_1.legal && doc_1.technical ? "PPT y PCAP" : doc_1.legal ? "Pliego de cl\xE1usulas administrativas" : "Pliego de prescripciones t\xE9cnicas"}</div></div></button>)}</CollapsibleContent></Collapsible>;
    T1 = Conversation;
    t5 = "min-h-0 flex-1";
    T0 = ConversationContent;
    if ($[44] !== messages.length) {
      t3 = messages.length === 0 && <div className="text-muted-foreground flex h-full items-center justify-center text-center text-sm"><p>Pregunta cualquier cosa sobre esta licitación.<br />Puedo ayudarte con requisitos, plazos, presupuestos y más.<br /><br />Por ejemplo, prueba con:<br /><i>"¿Cuáles son los criterios objetivos de adjudicación?"</i><br /><i>"¿Cuánto dura el período de garantía?"</i></p></div>;
      $[44] = messages.length;
      $[45] = t3;
    } else {
      t3 = $[45];
    }
    t4 = messages.map((message_0, messageIndex) => {
      const groundingPart = message_0.parts.find(_temp2);
      const groundingData = groundingPart ? groundingPart.data as {
        chunks: {
          retrievedContext: {
            title: string;
            text: string;
          };
        }[];
        supports: {
          segment: {
            startIndex: number;
            endIndex: number;
            text: string;
          };
          groundingChunkIndices: number[];
        }[];
      } : undefined;
      return <div key={message_0.id}>{message_0.parts.map((part_0, i) => {
          switch (part_0.type) {
            case "text":
              {
                const renderTextWithCitations = () => {
                  if (!groundingData?.supports.length) {
                    return part_0.text;
                  }
                  const sentenceCitations = new Map();
                  groundingData.supports.forEach(support => {
                    const {
                      endIndex
                    } = support.segment;
                    const regex = /[.!?:]\s|[.!?:]$/;
                    const sentenceEndMatch = regex.exec(part_0.text.slice(endIndex));
                    const sentenceEndPos = sentenceEndMatch ? endIndex + sentenceEndMatch.index + 1 : part_0.text.length;
                    if (!sentenceCitations.has(sentenceEndPos)) {
                      sentenceCitations.set(sentenceEndPos, new Set());
                    }
                    const citationSet = sentenceCitations.get(sentenceEndPos);
                    if (citationSet) {
                      support.groundingChunkIndices.forEach(idx_0 => {
                        citationSet.add(idx_0 + 1);
                      });
                    }
                  });
                  let result = "";
                  let lastIndex = 0;
                  const sortedPositions = Array.from(sentenceCitations.keys()).sort(_temp3);
                  sortedPositions.forEach(pos => {
                    const citationSet_0 = sentenceCitations.get(pos);
                    if (citationSet_0) {
                      const citations = Array.from(citationSet_0).sort(_temp4).join(",");
                      result = result + part_0.text.slice(lastIndex, pos);
                      result;
                      result = result + `<sup>[${citations}]</sup>`;
                      result;
                      lastIndex = pos;
                    }
                  });
                  if (lastIndex < part_0.text.length) {
                    result = result + part_0.text.slice(lastIndex);
                    result;
                  }
                  return result;
                };
                return <Message key={`${message_0.id}-${i.toString()}`} from={message_0.role}><MessageContent><MessageResponse>{renderTextWithCitations()}</MessageResponse></MessageContent>{message_0.role === "assistant" && <MessageActions>{messageIndex === messages.length - 1 && <MessageAction onClick={() => void regenerate()} label="Retry"><RefreshCcwIcon className="size-3" /></MessageAction>}<MessageAction onClick={() => void navigator.clipboard.writeText(part_0.text)} label="Copy"><CopyIcon className="size-3" /></MessageAction></MessageActions>}</Message>;
              }
            case "reasoning":
              {
                return <Reasoning key={`${message_0.id}-${i.toString()}`} className="w-full" isStreaming={status === "streaming" && i === message_0.parts.length - 1 && message_0.id === messages.at(-1)?.id} defaultOpen={false}><ReasoningTrigger getThinkingMessage={getTenderThinkingMessage} /><ReasoningContent>{part_0.text}</ReasoningContent></Reasoning>;
              }
            default:
              {
                return null;
              }
          }
        })}{message_0.role === "assistant" && groundingData?.chunks && groundingData.chunks.length > 0 && (() => {
          const usedIndices = new Set();
          groundingData.supports.forEach(support_0 => {
            support_0.groundingChunkIndices.forEach(idx_1 => {
              usedIndices.add(idx_1);
            });
          });
          const usedChunks = groundingData.chunks.filter((_, idx_2) => usedIndices.has(idx_2));
          if (usedChunks.length === 0) {
            return null;
          }
          return <div className="mt-6 space-y-2 border-t pt-4"><h4 className="text-sm font-semibold">Referencias</h4><div className="space-y-2">{usedChunks.map(chunk => {
                const originalIdx = groundingData.chunks.indexOf(chunk);
                const pageRegex = /---\s*PAGE\s+(\d+)\s*---/i;
                const pageMatch = pageRegex.exec(chunk.retrievedContext.text);
                const pageNumber_0 = pageMatch?.[1] ? parseInt(pageMatch[1], 10) : undefined;
                return <details key={`ref-${originalIdx.toString()}`} className="group bg-muted/50 hover:bg-muted rounded-md border p-3 transition-colors"><summary className="hover:text-primary flex cursor-pointer items-start gap-2 text-sm font-medium transition-colors"><span className="flex-1"><span className="text-primary font-semibold">[{originalIdx + 1}]</span>{" "}{chunk.retrievedContext.title}</span><Button variant="ghost" size="icon" className="size-6 shrink-0" onClick={e => {
                      e.preventDefault();
                      handleReferenceClick(chunk.retrievedContext.title, chunk.retrievedContext.text, pageNumber_0);
                    }} title="Abrir en visor PDF"><ExternalLinkIcon className="size-3" /></Button></summary><div className="text-muted-foreground border-primary/20 mt-2 border-l-2 pl-4 text-xs whitespace-pre-wrap">{chunk.retrievedContext.text.trim()}</div></details>;
              })}</div></div>;
        })()}</div>;
    });
    $[2] = disabled;
    $[3] = isLoggedIn;
    $[4] = messages;
    $[5] = open;
    $[6] = regenerate;
    $[7] = router;
    $[8] = selectedDocument;
    $[9] = sendMessage;
    $[10] = sourcesOpen;
    $[11] = status;
    $[12] = storeId;
    $[13] = tender.documents;
    $[14] = tender.title;
    $[15] = T0;
    $[16] = T1;
    $[17] = T2;
    $[18] = T3;
    $[19] = handleSubmit;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    T0 = $[15];
    T1 = $[16];
    T2 = $[17];
    T3 = $[18];
    handleSubmit = $[19];
    t10 = $[20];
    t11 = $[21];
    t12 = $[22];
    t13 = $[23];
    t3 = $[24];
    t4 = $[25];
    t5 = $[26];
    t6 = $[27];
    t7 = $[28];
    t8 = $[29];
    t9 = $[30];
  }
  let t14;
  if ($[46] !== messages || $[47] !== status) {
    t14 = (status === "submitted" || status === "streaming" && messages.length > 0 && messages.at(-1)?.role === "assistant" && !messages.at(-1)?.parts.some(_temp5)) && <Loader />;
    $[46] = messages;
    $[47] = status;
    $[48] = t14;
  } else {
    t14 = $[48];
  }
  let t15;
  if ($[49] !== T0 || $[50] !== t14 || $[51] !== t3 || $[52] !== t4) {
    t15 = <T0>{t3}{t4}{t14}</T0>;
    $[49] = T0;
    $[50] = t14;
    $[51] = t3;
    $[52] = t4;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <ConversationScrollButton />;
    $[54] = t16;
  } else {
    t16 = $[54];
  }
  let t17;
  if ($[55] !== T1 || $[56] !== t15 || $[57] !== t5) {
    t17 = <T1 className={t5}>{t15}{t16}</T1>;
    $[55] = T1;
    $[56] = t15;
    $[57] = t5;
    $[58] = t17;
  } else {
    t17 = $[58];
  }
  let t18;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = e_0 => {
      setInput(e_0.target.value);
    };
    $[59] = t18;
  } else {
    t18 = $[59];
  }
  let t19;
  if ($[60] !== input) {
    t19 = <PromptInputBody><PromptInputTextarea onChange={t18} value={input} placeholder={"Pregunta sobre esta licitaci\xF3n..."} /></PromptInputBody>;
    $[60] = input;
    $[61] = t19;
  } else {
    t19 = $[61];
  }
  const t20 = !input && !status;
  let t21;
  if ($[62] !== stop) {
    t21 = () => void stop();
    $[62] = stop;
    $[63] = t21;
  } else {
    t21 = $[63];
  }
  let t22;
  if ($[64] !== status || $[65] !== t20 || $[66] !== t21) {
    t22 = <PromptInputFooter className="justify-end"><PromptInputSubmit disabled={t20} status={status} onStop={t21} /></PromptInputFooter>;
    $[64] = status;
    $[65] = t20;
    $[66] = t21;
    $[67] = t22;
  } else {
    t22 = $[67];
  }
  let t23;
  if ($[68] !== handleSubmit || $[69] !== t19 || $[70] !== t22) {
    t23 = <PromptInput onSubmit={handleSubmit} className="shrink-0" globalDrop={false} multiple={false}>{t19}{t22}</PromptInput>;
    $[68] = handleSubmit;
    $[69] = t19;
    $[70] = t22;
    $[71] = t23;
  } else {
    t23 = $[71];
  }
  let t24;
  if ($[72] !== t17 || $[73] !== t23 || $[74] !== t6 || $[75] !== t7) {
    t24 = <div className={t6}>{t7}{t17}{t23}</div>;
    $[72] = t17;
    $[73] = t23;
    $[74] = t6;
    $[75] = t7;
    $[76] = t24;
  } else {
    t24 = $[76];
  }
  let t25;
  if ($[77] !== searchText || $[78] !== selectedDocument || $[79] !== selectedPage) {
    t25 = selectedDocument && <div className="flex min-h-0 w-full flex-col border-l md:w-1/2"><div className="flex items-center justify-between border-b p-3"><div className="flex-1 overflow-hidden"><h3 className="truncate text-sm font-semibold">{selectedDocument.title}</h3><p className="text-muted-foreground text-xs">{selectedDocument.legal && selectedDocument.technical ? "PPT y PCAP" : selectedDocument.legal ? "Pliego de cl\xE1usulas administrativas" : "Pliego de prescripciones t\xE9cnicas"}</p></div><Button variant="ghost" size="icon" onClick={() => {
          setSelectedDocument(null);
          setSearchText(null);
          setSelectedPage(null);
        }} className="shrink-0"><XIcon className="size-4" /></Button></div><div className="flex-1 overflow-hidden"><iframe src={(() => {
          const url = selectedDocument.url;
          const params = [];
          if (selectedPage) {
            params.push(`page=${selectedPage.toString()}`);
          }
          if (searchText) {
            params.push(`search="${encodeURIComponent(searchText)}"`, "phrase=true");
          }
          return params.length > 0 ? `${url}#${params.join("&")}` : url;
        })()} className="size-full" title={selectedDocument.title} /></div></div>;
    $[77] = searchText;
    $[78] = selectedDocument;
    $[79] = selectedPage;
    $[80] = t25;
  } else {
    t25 = $[80];
  }
  let t26;
  if ($[81] !== t24 || $[82] !== t25 || $[83] !== t8) {
    t26 = <div className={t8}>{t24}{t25}</div>;
    $[81] = t24;
    $[82] = t25;
    $[83] = t8;
    $[84] = t26;
  } else {
    t26 = $[84];
  }
  let t27;
  if ($[85] !== T2 || $[86] !== t10 || $[87] !== t26 || $[88] !== t9) {
    t27 = <T2 className={t9}>{t10}{t26}</T2>;
    $[85] = T2;
    $[86] = t10;
    $[87] = t26;
    $[88] = t9;
    $[89] = t27;
  } else {
    t27 = $[89];
  }
  let t28;
  if ($[90] !== T3 || $[91] !== t11 || $[92] !== t12 || $[93] !== t13 || $[94] !== t27) {
    t28 = <T3 open={t11} onOpenChange={t12}>{t13}{t27}</T3>;
    $[90] = T3;
    $[91] = t11;
    $[92] = t12;
    $[93] = t13;
    $[94] = t27;
    $[95] = t28;
  } else {
    t28 = $[95];
  }
  return t28;
}
function _temp5(part_1) {
  return (part_1.type === "text" || part_1.type === "reasoning") && part_1.text.trim().length > 0;
}
function _temp4(a_0, b_0) {
  return a_0 - b_0;
}
function _temp3(a, b) {
  return a - b;
}
function _temp2(part) {
  return typeof part === "object" && "type" in part && typeof part.type === "string" && part.type.startsWith("data-") && "data" in part;
}
function _temp(doc) {
  return Boolean(doc.legal) || Boolean(doc.technical);
}